// extracted by mini-css-extract-plugin
export default {"variables":"design-variables-viewer_variables__54n2V","container":"design-variables-viewer_container__wvGz1","label":"design-variables-viewer_label__CtJiQ"};